import { getNestedProperty } from 'utils/utils';
import InputErrorMessage from '../InputErrorMessage/InputErrorMessage';

export const RequiredValidation = ({ field, message = 'Field Required', errors = {} }) => {
  return getNestedProperty(errors, field) ? (
    <InputErrorMessage>{getNestedProperty(errors, field)?.message || message}</InputErrorMessage>
  ) : null;
};
